import {useState, useEffect, useCallback} from 'react'
import {searchUsersForMention} from '../core/_requests'
import {ID} from '../../../../../../../../../_metronic/helpers'

export type User = {
  id: number
  name: string
  avatar?: string | null
}

export const useMentions = (query: string, debounceMs: number = 300) => {
  const [users, setUsers] = useState<User[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const searchUsers = useCallback(
    async (searchQuery: string) => {
      // Allow search even with empty query to show all users when just "@" is typed
      setLoading(true)
      setError(null)

      try {
        const response = await searchUsersForMention(searchQuery || '')
        setUsers(response.data || [])
      } catch (err: any) {
        setError(err.response?.data?.message || 'Erro ao buscar usuários')
        setUsers([])
      } finally {
        setLoading(false)
      }
    },
    []
  )

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      searchUsers(query)
    }, debounceMs)

    return () => clearTimeout(timeoutId)
  }, [query, debounceMs, searchUsers])

  return {users, loading, error}
}
